export function TermsOfUse() {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      {/* מבוא */}
      <h1 className="text-3xl font-bold mb-6">תקנון האתר</h1>
      <p className="mb-4">
        ברוכים הבאים לאתר <strong>anizone.co.il</strong> (להלן: "האתר") המופעל
        על ידי <strong>אניזון בע"מ</strong>,
       (להלן: "הנהלת האתר" ו/או
        "החברה").
      </p>
      <p className="mb-4">
        כל שימוש באתר מהווה הסכמה לתקנון זה, על התנאים וההגבלות הכלולים בו.
        התקנון עלול להשתנות מעת לעת, ועל המשתמש להתעדכן בתקנון בכל כניסה לאתר.
        גלישה באתר ו/או שימוש בו מכל סוג, מהווים הסכמה לתנאי התקנון והתחייבות
        לפעול על פיהם. מובהר כי התקנון מהווה הסכם משפטי מחייב לכל דבר ועניין.
      </p>
      <p className="mb-4">
        האמור בתקנון זה בלשון זכר הוא לשם הנוחות בלבד והתקנון מתייחס לבני שני
        המינים באופן שווה. השירותים באמצעות האתר כפופים לתנאים המפורטים בתקנון
        זה. עצם הזמנת השירותים באתר תהווה הצהרה מצד הלקוח כי קרא, הבין והסכים
        להוראות התקנון.
      </p>

      {/* שירותים */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">השירותים</h2>
      <p className="mb-4">
        האתר מאפשר שירותי <strong>תוכן בידורי ומידע עדכני</strong> וכן גישה
        למאמרים, וידאוים ובלוג. ניתן להזמין שירותים נוספים באמצעות יצירת קשר עם
        הנהלת האתר בהתאם לזמינותו ומיקומו הגיאוגרפי.
      </p>
      <p className="mb-4">
        ניתן לשלם עבור שירותי האתר באמצעות{' '}
        <strong>כרטיס אשראי ישראלי תקף</strong> או באמצעות{' '}
        <strong>העברה בנקאית</strong> בכפוף לאישור הנהלת האתר. מחיר השירותים
        המוצגים הם ללא מע"מ, בכפוף לחוק המיסים עבור "חברה בע"מ".
      </p>
      <p className="mb-4">
        הנהלת האתר שומרת לעצמה את הזכות להפסיק את שירותיה בכל עת.
      </p>
      <p className="mb-4">
        הזכאות לשימוש באתר הינה לכל אזרח אשר מלאו לו <strong>18</strong> שנים.
        הזמנה תתאפשר למי שברשותו חשבון בנק פעיל ו/או כרטיס אשראי ישראלי תקף, וכן
        בעל תיבת דואר אלקטרוני תקינה. קטין המבצע פעולות ייחשב כקטין אשר קיבל את
        רשות הוריו או אפוטרופוסיו.
      </p>

      {/* ביטולים ושינוי שירותים */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">
        ביטולים ושינוי סוגי השירותים
      </h2>
      <p className="mb-4">
        מדיניות ביטול עסקה והחזרת מוצרים היא בהתאם לתקנות הגנת הצרכן
        (התשע"א-2010) וחוק הגנת הצרכן, התשמ"א-1981.
      </p>
      <p className="mb-4">
        ניתן לבטל שירות אשר נקבע עבור לקוח בכל עת, בכפוף לכך שהלקוח יידע את
        הנהלת האתר על ביטול או שינוי המועד לפחות 30 ימים לפני סיום ההתקשרות.
      </p>
      <p className="mb-4">
        ביטול הזמנה יתאפשר עד 24 שעות ממועד ביצוע ההזמנה, בתנאי שההזמנה טרם יצאה
        למשלוח. במקרה של ביטול שירותים, הלקוח לא יחוייב עבור השירות.
      </p>
      <p className="mb-4">
        לא ניתן לקבל החזר כספי עבור שירותים אשר כבר בוצעו. האתר רשאי לבטל אספקת
        הזמנה למשתמש בהתראה של שעתיים מראש, ובמקרה כזה לא תעמוד למשתמש כל טענה
        כלפי האתר.
      </p>
      <p className="mb-4">
        הודעות על ביטול או הפסקה מצד החברה תימסרנה למשתמש, והחברה תימנע מחיוב
        כרטיס האשראי או תחזיר כל סכום ששולם בגין השירותים.
      </p>

      {/* זמינות ומיקום אזורי */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">זמינות ומיקום אזורי</h2>
      <p className="mb-4">
        זמינות השירותים כפופה למועדים אשר ייקבעו עם הנהלת האתר. לכל שאלה או
        בירור, ניתן ליצור קשר בטלפון <strong>03-1234567</strong>.
      </p>

      {/* מדיניות משלוחים */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">מדיניות משלוחים</h2>
      <p className="mb-4">
        מרבית השירותים והמוצרים באתר מוכנים למשלוח תוך <strong>3-5</strong> ימי
        עסקים. ניתן לבחור בין סוגי משלוחים כגון:
      </p>
      <ul className="list-disc text-softText list-inside mb-4">
        <li>איסוף עצמי מבית העסק</li>
        <li>איסוף עצמי ממרכז המשלוחים</li>
        <li>משלוח עד הבית</li>
      </ul>
      <p className="mb-4">עלויות המשלוח מופיעות בעמוד התשלום.</p>

      {/* אחריות ושירות */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">אחריות ושירות</h2>
      <p className="mb-4">
        השירותים יינתנו בהתאם לחבילות השירות המוצעות על ידי הנהלת האתר, כאשר
        אורך השירות הוא על פי המועד שנקבע מראש.
      </p>
      <p className="mb-4">
        הנהלת האתר אינה אחראית לנזקים פיזיים, כספיים או נזק אחר הנגרם במהלך
        השימוש בשירותים או בעקבות השימוש במוצרים.
      </p>
      <p className="mb-4">
        כמו כן, הנהלת האתר אינה נושאת באחריות לתכנים המפורסמים באתר או להשלכות
        השימוש בהם.
      </p>

      {/* אבטחת מידע ופרטיות */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">אבטחת מידע ופרטיות</h2>
      <p className="mb-4">
        הנהלת האתר, יחד עם חברות אחיות וגורמי משנה הפועלים מטעמנו, רשאים להשתמש
        במידע האישי המופיע בטפסים לצורך אספקת השירותים. מידע זה לא ייחשף, לא
        יעשה בו שימוש למטרות שיווקיות ללא אישור, ולא יועבר לצד שלישי ללא הסכמה
        מפורשת מהלקוח.
      </p>
      <p className="mb-4">
        תוכן השירות ונתונים אישיים המועברים במהלך השירות לא ייחשפו לגורם אחר אלא
        באישור בכתב מהלקוח. פרטיות המשתמשים היא בראש סדר העדיפויות שלנו.
      </p>
      <p className="mb-4">
        האתר מאובטח באמצעי אבטחה מתקדמים שמטרתם להבטיח גלישה בטוחה ושמירה על
        פרטיות המשתמשים. המשתמש מתחייב שלא יבצע פעילות שתשבש את פעילות האתר או
        תגרום לגניבת מידע.
      </p>
      <p className="mb-4">
        במקרה של שימוש לרעה, הנהלת האתר תנקוט בכל האמצעים החוקיים, לרבות חסימת
        המשתמש ונקיטת הליכים משפטיים.
      </p>

      {/* קניין רוחני */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">קניין רוחני</h2>
      <p className="mb-4">
        כל זכויות הקניין הרוחני, לרבות זכויות יוצרים, סימני מסחר, סודות מסחריים
        וכל זכויות אחרות הקשורות לעיצוב האתר ולתכנים המופיעים בו, הן רכושם
        הבלעדי של הנהלת האתר.
      </p>
      <p className="mb-4">
        אין להעתיק, לשכפל, להפיץ, לפרסם או להשתמש בתכנים מהאתר ללא אישור מראש
        ובכתב מהנהלת האתר.
      </p>

      {/* דין וסמכות שיפוט */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">דין וסמכות שיפוט</h2>
      <p className="mb-4">
        פרשנותו ואכיפתו של תקנון זה וכל סכסוך הנובע ממנו יהיו כפופים לדין
        הישראלי בלבד. בתי המשפט ב<strong>תל אביב-יפו</strong> יהיו בעלי סמכות
        שיפוט בלעדית.
      </p>

      {/* יצירת קשר */}
      <h2 className="text-2xl font-semibold mt-8 mb-4">יצירת קשר</h2>
      <p className="mb-4">
        לכל שאלה ופנייה ניתן ליצור קשר עם הנהלת האתר בטלפון{' '}
        <strong></strong> או במייל <strong>info@anizone.co.il</strong>{' '}
        בשעות הפעילות של האתר.
      </p>
    </div>
  )
}
